import React, { useEffect, useState } from "react";
import axios from "axios";

function RenewEnergyTabs({ plantId }) {
  const [overview, setOverview] = useState({});
  const [officials, setOfficials] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!plantId) return;

    const fetchAll = async () => {
      setLoading(true);
      try {
        const [overviewRes, officialsRes] = await Promise.all([
          axios.get(` https://backend-zkgn.onrender.com/api/renewableplants/${plantId}`),
          axios.get(` https://backend-zkgn.onrender.com/api/renewable_officials/${plantId}`),
        ]);

        setOverview(overviewRes.data || {});
        setOfficials(officialsRes.data || []);
      } catch (err) {
        console.error(err);
        setError("Failed to load renewable energy plant data.");
      } finally {
        setLoading(false);
      }
    };

    fetchAll();
  }, [plantId]);

  if (loading) return <div className="text-center my-5">Loading...</div>;
  if (error) return <div className="text-danger my-5">{error}</div>;

  return (
    <div className="container my-5">
      {/* Tab headers */}
      <ul className="nav nav-tabs custom-tabs" id="renewTab" role="tablist">
        <li className="nav-item">
          <button
            className="nav-link active"
            data-bs-toggle="tab"
            data-bs-target="#overview"
          >
            Overview
          </button>
        </li>
        <li className="nav-item">
          <button
            className="nav-link"
            data-bs-toggle="tab"
            data-bs-target="#officials"
          >
            Officials
          </button>
        </li>
      </ul>

      {/* Tab content */}
      <div
        className="tab-content p-4 border border-top-0 rounded-bottom shadow-sm"
        id="renewTabContent"
      >
        {/* Overview */}
        <div className="tab-pane fade show active" id="overview">
          <h4 className="mb-4">Overview</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <tbody>
                <tr>
                  <th>Plant Name</th>
                  <td>{overview.renergy_name}</td>
                </tr>
                <tr>
                  <th>Address</th>
                  <td>{overview.renergy_address}</td>
                </tr>
                <tr>
                  <th>City</th>
                  <td>{overview.renergy_city}</td>
                </tr>
                <tr>
                  <th>State</th>
                  <td>{overview.renergy_state}</td>
                </tr>
                <tr>
                  <th>Phone</th>
                  <td>{overview.renergy_phone}</td>
                </tr>
                {overview.renergy_email && (
                  <tr>
                    <th>Email</th>
                    <td>{overview.renergy_email}</td>
                  </tr>
                )}
                {overview.renergy_website && (
                  <tr>
                    <th>Website</th>
                    <td>
                      <a
                        href={
                          overview.renergy_website.startsWith("http")
                            ? overview.renergy_website
                            : `https://${overview.renergy_website}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {overview.renergy_website}
                      </a>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {/* Officials */}
        <div className="tab-pane fade" id="officials">
          <h4 className="mb-4">Plant Officials</h4>
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Designation</th>
                  <th>Name</th>
                  <th>Mobile</th>
                  <th>Phone</th>
                  <th>Email</th>
                </tr>
              </thead>
              <tbody>
                {officials.length === 0 ? (
                  <tr>
                    <td colSpan="5">No officials found</td>
                  </tr>
                ) : (
                  officials.map((o) => (
                    <tr key={o.renergy_officials_id}>
                      <td>{o.renergy_officials_designation}</td>
                      <td>{o.renergy_officials_name}</td>
                      <td>{o.renergy_phone}</td>
                      <td>{o.renergy_phone}</td>
                      <td>{o.renergy_officials_email}</td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default RenewEnergyTabs;
